import { Component, ReactNode } from 'react';

interface BreakpointProps {
  children: ReactNode;
  compare: (a: number, b: number) => boolean;
}

interface BreakpointState {
  breakIn: boolean;
}

const defaultProps = {
  children: null,
};

class Breakpoint extends Component<BreakpointProps, BreakpointState> {
  public static defaultProps = defaultProps;

  public constructor(props: BreakpointProps) {
    super(props);
    this.state = {
      breakIn: props.compare(window.innerWidth, window.innerHeight),
    };
    this.handleResize = this.handleResize.bind(this);
  }

  public componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  public handleResize() {
    const { compare } = this.props;
    const breakIn = compare(window.innerWidth, window.innerHeight);
    this.setState({ breakIn });
  }

  public render() {
    const { children } = this.props;
    const { breakIn } = this.state;
    return breakIn ? children : null;
  }
}

export default Breakpoint;
